export interface BIA {
    contIntern: string;
    codeTypeEffet: number;
    contrat: string;
    createdAt: string;
    dateEffet: string;
    dateEmbauche: string;
    dateNaissance: string;
    id: number | null;
    idAssure: string;
    idBiaContrat: number | null;
    idSouscripteur: string;
    info: string;
    libelle: string;
    libelleTypeEffet: string;
    modifiedAt: string;
    nom: string;
    numSecu: string;
    prenom: string;
    produit: string;
    siret: string;
    tarifCoti: string;
    anciennete?: number;
    debVal?: any;
}

export const initBIA = {
    contIntern: '',
    codeTypeEffet: 0,
    contrat: '',
    createdAt: '',
    dateEffet: '',
    dateEmbauche: '',
    dateNaissance: '',
    id: 0,
    idAssure: '',
    idBiaContrat: 0,
    idSouscripteur: '',
    info: '',
    libelle: '',
    libelleTypeEffet: '',
    modifiedAt: '',
    nom: '',
    numSecu: '',
    prenom: '',
    produit: '',
    siret: '',
    tarifCoti: '',
};

export type CacheData = {
    action: string;
    idAssure: string;
    dateEmbauche: string;
    dateEffet: string;
    sansSuite: boolean;
    contIntern: string;
    newContrat: string;
    id: string;
    nom: string;
    prenom: string;
    numSecu: string;
    mode: string;
};
export type BiaToValidate = {
    idAssure: string;
    dateEmbauche: string;
    dateEffet: string;
    sansSuite: boolean;
    contIntern: string;
    newContrat: string;
    nom: string;
    prenom: string;
    numSecu: string;
    CommandCacheData: string;
};
